import * as _ from "lodash";
import { TablePagination } from "../components/pln-table/pln-table.component";

export class HttpHelper {
  /**
   * @author Paulo Carriço
   * @description médoto para tratar um objeto e converter query para envio api GET
   * @param filters objeto contendo os filtros ex.: {name: 'jose', status:'a'}
   * @param pagination informa se a query sera montada com paginação
   * @returns string contendo a query ex.: ?name=jose&status=a&page=1&limit=5
   */
  public getQueryParams(filters: any, pagination: boolean): string {
    const values = [];
    _.map(Object.keys(filters), (key) => {
      values.push(_.trim(filters[key]));
    });

    let queryParams = this.prepareQueryParams(
      {
        elements: Object.keys(filters),
        values: values,
      },
      filters
    );

    if (pagination && _.isUndefined(filters.limit))
      queryParams += this.preparePaginationParams(filters);

    return queryParams;
  }

  public prepareQueryParams(
    queryParams: { elements: any[]; values: any[] },
    filters: any = []
  ) {
    let queryParamsUrl = "?";
    queryParams.elements.forEach((element, index) => {
      if (Array.isArray(filters[element])) {
        filters[element].forEach((arrValue: any) => {
          queryParamsUrl = `${queryParamsUrl}${element}[]=${arrValue}&`;
        });
      } else {
        queryParamsUrl = `${queryParamsUrl}${element}=${queryParams.values[index]}&`;
      }
    });

    queryParamsUrl = queryParamsUrl.substr(0, queryParamsUrl.length - 1);

    return queryParamsUrl;
  }

  public preparePaginationParams(filters: TablePagination): string {
    return `&limit=${filters.limit || 10}&page=${filters.page || 1}`;
  }
}
